export interface SizeBreakdownEntry {
  shirtSizeId: string;
  label: string;
  quantity: number;
}

/** Soma das quantidades já distribuídas entre os tamanhos de um item. */
export function sizeBreakdownTotal(breakdown: SizeBreakdownEntry[] | null | undefined) {
  return (breakdown ?? []).reduce((sum, entry) => sum + entry.quantity, 0);
}

/** Um item só está "completo" quando a soma dos tamanhos bate exatamente com a quantidade. */
export function isSizeBreakdownComplete(
  quantity: number,
  breakdown: SizeBreakdownEntry[] | null | undefined,
) {
  return sizeBreakdownTotal(breakdown) === quantity;
}

/**
 * `shirtSizeId` na linha do item é só uma conveniência pro caso comum de 1 tamanho só
 * (mantém telas antigas que leem `item.shirtSize` funcionando sem mudança) — quando o item
 * tem 2+ tamanhos ou nenhum, esse campo fica nulo e o detalhamento vem de `sizeBreakdown`.
 */
export function deriveShirtSizeId(breakdown: SizeBreakdownEntry[] | null | undefined) {
  return breakdown?.length === 1 ? breakdown[0]!.shirtSizeId : undefined;
}

/** Resumo textual do breakdown pra exibir em telas/relatórios (ex: "P: 5 · M: 4 · G: 3"). */
export function formatSizeBreakdown(breakdown: SizeBreakdownEntry[] | null | undefined) {
  if (!breakdown?.length) return null;
  return breakdown.map((entry) => `${entry.label}: ${entry.quantity}`).join(' · ');
}
